var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUiUx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#4da3ff",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#4da3ff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 8",
    id: "Layer_8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,30H11a5,5,0,0,1-5-5V7a5,5,0,0,1,5-5h8a1,1,0,0,1,.71.29l6,6A1,1,0,0,1,26,9V25A5,5,0,0,1,21,30ZM11,4A3,3,0,0,0,8,7V25a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3V9.41L18.59,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,16H19V13a1,1,0,0,0-1-1H14a1,1,0,0,0-1,1v3H12a1,1,0,0,0-.92.62,1,1,0,0,0,.21,1.09l4,4a1,1,0,0,0,1.42,0l4-4a1,1,0,0,0,.21-1.09A1,1,0,0,0,20,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.71,8.29l-6-6a1,1,0,0,0-1.09-.21A1,1,0,0,0,18,3V8a2,2,0,0,0,2,2h5a1,1,0,0,0,.92-.62A1,1,0,0,0,25.71,8.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,29H8V16.63c0,2,2.08,8.08,6.58,8.08,4,0,9.42-1,9.42-4.92Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiUx);
export default __webpack_public_path__ + "static/media/ui-ux.40b44635fc2003f0895a8da8f0cac823.svg";
export { ForwardRef as ReactComponent };